import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type PageHeroProps = {
  eyebrow?: string;
  title: string;
  intro?: string;
  children?: ReactNode;
  className?: string;
};

export function PageHero({
  eyebrow,
  title,
  intro,
  children,
  className,
}: PageHeroProps) {
  return (
    <section className={cn("relative overflow-hidden pb-16 pt-36", className)}>
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-40 -top-40 h-[500px] w-[500px] rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -left-32 top-60 h-[300px] w-[300px] rounded-full bg-accent/8 blur-3xl" />
      </div>
      <div className="relative mx-auto max-w-4xl px-5 text-center">
        {eyebrow ? (
          <p className="mb-4 text-xs font-bold uppercase tracking-widest text-primary">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="font-heading text-4xl font-bold leading-tight tracking-tight text-[#1a3a5c] md:text-6xl">
          {title}
        </h1>
        {intro ? (
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground">
            {intro}
          </p>
        ) : null}
        {children}
      </div>
    </section>
  );
}
